import WorkClient from '../api/workClient';

const getOrderInfoByTransferId = (transferOrderId?: string) => {
  return WorkClient.getOrderInfoByTransferId(transferOrderId);
};

const getOrdersForWorkplan = (workTaskId: number) => {
  return WorkClient.getOrdersForWorkplan(workTaskId);
};

const isOrderValidForConsumption = (orderId: number) => {
  return WorkClient.isOrderValidForConsumption(orderId);
};

const getMrpOrdersByWarehouse = (warehouseId: string) => {
  return WorkClient.getMrpOrdersByWarehouse(warehouseId);
};

const getOrderedItems = (taskTypeId: number) => {
  return WorkClient.getOrderedItems(taskTypeId)
}

const OrdersService = {
  getOrdersForWorkplan,
  getOrderInfoByTransferId,
  isOrderValidForConsumption,
  getMrpOrdersByWarehouse,
  getOrderedItems
};

export default OrdersService;
